export default {
      id: "icon-price-usage",
      viewBox: "0 0 113 129",
      url: __webpack_public_path__ + "icons.svg#icon-price",
      toString: function () {
        return this.url;
      }
    }